import { render, staticRenderFns } from "./TeamHe.vue?vue&type=template&id=b4d19b3a&"
import script from "./TeamHe.vue?vue&type=script&lang=js&"
export * from "./TeamHe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports